import React from 'react';
import styles from "../faq/faq.module.css";


const ReturnRefund = () => {

    return (
        <div className={styles.container}>
            <h2>Cancellation & Refund Policy</h2>

            <div className={styles.contentForTermsCondition}>

                <p style={{ fontWeight: 'medium' }}> At Pavithra Jewels, we strive to provide our customers with a seamless shopping experience. Please review our cancellation and refund policy below:</p>  <br />
                <p style={{ fontWeight: 'bold' }}>Order Cancellation:</p>  <br />
                <p style={{ fontWeight: 'light' }}> Orders may be cancelled only before the dispatch process begins. If you wish to cancel your order, please contact our customer service team at the earliest via:</p>  <br />

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                    <ul>
                        <li><span style={{ fontWeight: 'medium' }}>Phone/WhatsApp:</span> 9845540125 / 9632429387 </li>
                        <li><span style={{ fontWeight: 'medium' }}>Email:</span> <a href='pavithrajewels916@gmail.com'> pavithrajewels916@gmail.com</a> </li>
                    </ul>
                </div>

                <br /> <p style={{ fontWeight: 'light' }}>Upon successful cancellation, the refund will be processed to the original mode of payment within 2–3 working days.</p> <br />

                <p style={{ fontWeight: 'bold' }}>Please Note:</p>  <br />

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                    <ul>
                        <li>Cancellations are not permitted once the product has been dispatched or delivered.</li>
                        <li>Returns are not accepted under any circumstances due to the nature of our business.</li>
                    </ul>
                </div> <br />
                <p style={{ fontWeight: 'light' }}>We appreciate your understanding and thank you for choosing Pavithra Jewels.</p>
            </div>

            <div className={styles.mobile_contant}>

                <p style={{ fontWeight: 'medium' }}> At Pavithra Jewels, we strive to provide our customers with a seamless shopping experience. Please review our cancellation and refund policy below:</p>  <br />
                <p style={{ fontWeight: 'bold' }}>Order Cancellation:</p>  <br />
                <p style={{ fontWeight: 'light' }}> Orders may be cancelled only before the dispatch process begins. If you wish to cancel your order, please contact our customer service team at the earliest via:</p>  <br />

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                    <ul>
                        <li><span style={{ fontWeight: 'medium' }}>Phone/WhatsApp:</span> <span style={{ whiteSpace: 'nowrap' }}>9845540125 / 9632429387</span></li>
                        <li><span style={{ fontWeight: 'medium' }}>Email:</span> <a href='pavithrajewels916@gmail.com'> pavithrajewels916@gmail.com</a> </li>
                    </ul>
                </div>

                <br /> <p style={{ fontWeight: 'light' }}>Upon successful cancellation, the refund will be processed to the original mode of payment within 2–3 working days.</p> <br />

                <p style={{ fontWeight: 'bold' }}>Please Note:</p>  <br />
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>

                    <ul>
                        <li>Cancellations are not permitted once the product has been dispatched or delivered.</li>
                        <li>Returns are not accepted under any circumstances due to the nature of our business.</li>
                    </ul>
                </div> <br />

                <p style={{ fontWeight: 'light' }}>We appreciate your understanding and thank you for choosing Pavithra Jewels.</p>

            </div>
        </div>
    );
};

export default ReturnRefund;
